export default {
  en: {
    online: 'You are back online!',
    offline: 'You are offline!',
  },
};
